import React, { createContext, useContext, useState, ReactNode } from 'react';
import { SpcStep, SpcSubStep } from './SpcSidebarFormNavigation';

interface SpcFormData {
  activeStepNumber?: number;
  activeStep?: SpcStep;
  activeSubStep?: SpcSubStep;
  nextStep?: any,
  stepsFlatList?: any;
  currentStep?: string | number;
  completedStep?: string | number;
  retirementSteps: any;
  data: any;
  errors?: any;
}

interface SpcFormContextType {
  formData: SpcFormData;
  updateFormData: (key: keyof SpcFormData, data: any) => void;
}

const SpcFormContext = createContext<SpcFormContextType | undefined>(undefined);

export const useForm = (): SpcFormContextType => {
  const context = useContext(SpcFormContext);
  if (!context) {
    throw new Error('useForm must be used within a FormProvider');
  }
  return context;
};

interface SpcFormProviderProps {
  children: ReactNode;
}

export const SpcFormProvider: React.FC<SpcFormProviderProps> = ({ children }) => {
  const [formData, setFormData] = useState<SpcFormData>({
    activeStepNumber: 0,
    currentStep: '',
    completedStep: '',
    retirementSteps: [],
    data: {},
    errors: []
  });

  const updateFormData = (key: keyof SpcFormData, data: any) => {
    setFormData((prev) => ({ ...prev, [key]: data }));
  };

  return (
    <SpcFormContext.Provider value={{ formData, updateFormData }}>
      {children}
    </SpcFormContext.Provider>
  );
};